import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { SectionComponent } from './section.component';
import {DirectivesModule} from '../../../directives/directives.module';
import {MatTooltipModule} from "@angular/material/tooltip";


@NgModule({
  declarations: [SectionComponent],
    imports: [
        CommonModule,
        MatButtonModule,
        MatIconModule,
        DirectivesModule,
        MatTooltipModule
    ],
  exports: [SectionComponent]
})
export class SectionModule { }
